var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "update-banner bg-white rounded-lg shadow-sm p-6 mb-10"
  }, [_c('header', {
    staticClass: "mb-8"
  }, [_c('h1', {
    staticClass: "text-xl font-bold text-neutral-700"
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "Edit Banner" : "Buat Banner Baru") + " ")])]), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-6"
  }, [_c('div', {
    staticClass: "space-y-6"
  }, [_c('div', [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v(" Nama Banner ")]), _c('TextField', {
    attrs: {
      "type": "text",
      "placeholder": "Masukkan nama banner"
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c('div', [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v(" Lokasi Banner ")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.locations,
      "default": _vm.form.location,
      "placeholder": "Pilih lokasi banner"
    },
    on: {
      "input": _vm.onSelectLocation
    }
  })], 1), _c('div', [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v(" Posisi ")]), _c('TextField', {
    attrs: {
      "type": "number",
      "placeholder": "Posisi tampil banner"
    },
    model: {
      value: _vm.form.position,
      callback: function ($$v) {
        _vm.$set(_vm.form, "position", $$v);
      },
      expression: "form.position"
    }
  })], 1)]), _c('div', {
    staticClass: "space-y-6"
  }, [_c('div', [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v(" Status ")]), _c('div', {
    staticClass: "flex gap-2"
  }, [_c('span', {
    staticClass: "px-4 py-1 rounded-full text-sm cursor-pointer transition",
    class: _vm.form.isActive ? _vm.activeClass : _vm.inactiveClass,
    on: {
      "click": function ($event) {
        _vm.form.isActive = true;
      }
    }
  }, [_vm._v(" Active ")]), _c('span', {
    staticClass: "px-4 py-1 rounded-full text-sm cursor-pointer transition",
    class: !_vm.form.isActive ? _vm.inactiveRedClass : _vm.inactiveClass,
    on: {
      "click": function ($event) {
        _vm.form.isActive = false;
      }
    }
  }, [_vm._v(" Inactive ")])])]), _c('div', [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v(" Gambar Banner ")]), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _c('div', {
    staticClass: "mt-3"
  }, [_vm.preview ? _c('img', {
    staticClass: "max-h-40 rounded-lg",
    attrs: {
      "src": _vm.preview,
      "alt": "Preview"
    }
  }) : _vm._e()])])]), _c('div', {
    staticClass: "md:col-span-2 space-y-4"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700"
  }, [_vm._v(" Tampilkan Banner Di ")]), _c('div', {
    staticClass: "grid grid-cols-1 sm:grid-cols-2 gap-4"
  }, [_c('div', {
    staticClass: "border rounded-lg p-4 flex flex-col gap-4"
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_vm._m(0), _c('button', {
    staticClass: "relative w-12 h-6 rounded-full transition-colors duration-200",
    class: _vm.form.isWeb ? 'bg-green-500' : 'bg-gray-300',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.form.isWeb = !_vm.form.isWeb;
      }
    }
  }, [_c('span', {
    staticClass: "absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transform transition-transform duration-200",
    class: _vm.form.isWeb ? 'translate-x-6' : 'translate-x-0'
  })])]), _vm.form.isWeb ? _c('div', [_c('label', {
    staticClass: "block text-xs font-medium text-neutral-700 mb-1"
  }, [_vm._v("Web Redirect URL")]), _c('TextField', {
    attrs: {
      "type": "text",
      "placeholder": "Masukkan URL redirect web"
    },
    model: {
      value: _vm.form.webRedirectUrl,
      callback: function ($$v) {
        _vm.$set(_vm.form, "webRedirectUrl", $$v);
      },
      expression: "form.webRedirectUrl"
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "border rounded-lg p-4 flex flex-col gap-4"
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_vm._m(1), _c('button', {
    staticClass: "relative w-12 h-6 rounded-full transition-colors duration-200",
    class: _vm.form.isMobile ? 'bg-green-500' : 'bg-gray-300',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.form.isMobile = !_vm.form.isMobile;
      }
    }
  }, [_c('span', {
    staticClass: "absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transform transition-transform duration-200",
    class: _vm.form.isMobile ? 'translate-x-6' : 'translate-x-0'
  })])]), _vm.form.isMobile ? _c('div', [_c('label', {
    staticClass: "block text-xs font-medium text-neutral-700 mb-1"
  }, [_vm._v("Mobile Redirect URL")]), _c('TextField', {
    attrs: {
      "type": "text",
      "placeholder": "Masukkan URL redirect mobile"
    },
    model: {
      value: _vm.form.mobileRedirectUrl,
      callback: function ($$v) {
        _vm.$set(_vm.form, "mobileRedirectUrl", $$v);
      },
      expression: "form.mobileRedirectUrl"
    }
  })], 1) : _vm._e()])])]), _c('div', [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v(" Badge Baru Sampai ")]), _c('TextField', {
    attrs: {
      "type": "datetime-local"
    },
    model: {
      value: _vm.form.badgeNewUntil,
      callback: function ($$v) {
        _vm.$set(_vm.form, "badgeNewUntil", $$v);
      },
      expression: "form.badgeNewUntil"
    }
  })], 1)]), _c('footer', {
    staticClass: "mt-8 flex justify-end gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/banner');
      }
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-primary-500 text-white hover:bg-primary-600 font-medium disabled:opacity-50",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" " + _vm._s(_vm.loading ? "Menyimpan..." : _vm.isEdit ? "Simpan Perubahan" : "Simpan Banner") + " ")])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticClass: "font-medium text-neutral-700"
  }, [_vm._v("Web")]), _c('p', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v("Banner tampil di website")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticClass: "font-medium text-neutral-700"
  }, [_vm._v("Mobile")]), _c('p', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v(" Banner tampil di aplikasi mobile ")])]);

}]

export { render, staticRenderFns }